(() => {
  const attached = new WeakSet();

  function updatePicker(picker, notify = false) {
    const top = picker.querySelector(
      'select[name="options[Top Size]"]'
    );
    const row = picker.querySelector(
      '[data-lillypad-trousers]'
    );
    const trousers = row?.querySelector('select');

    if (!top || !trousers) return;

    const options = [...trousers.options];
    const notRequired = options.find(
      option => option.value === 'Not Required'
    );

    if (!notRequired) return;

    const bodysuitOnly = [
      '0-3 Bodysuit Only',
      '3-6 Bodysuit Only'
    ].includes(top.value);

    row.style.display = bodysuitOnly ? 'none' : '';
    notRequired.hidden = !bodysuitOnly;
    notRequired.disabled = !bodysuitOnly;

    const firstSize = options.find(
      option => option.value !== 'Not Required'
    );

    const desired = bodysuitOnly
      ? 'Not Required'
      : trousers.value === 'Not Required'
        ? firstSize?.value
        : trousers.value;

    if (!desired || trousers.value === desired) return;

    trousers.value = desired;

    options.forEach(option => {
      option.toggleAttribute(
        'selected',
        option.value === desired
      );
    });

    if (notify) {
      trousers.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }
  }

  function attach(picker) {
    if (attached.has(picker)) return;
    if (!picker.querySelector(
      '[data-lillypad-trousers]'
    )) return;

    attached.add(picker);

    picker.addEventListener('change', event => {
      if (event.target.matches(
        'select[name="options[Top Size]"]'
      )) {
        updatePicker(picker);
      }
    }, true);

    new MutationObserver(() => {
      updatePicker(picker, true);
    }).observe(picker, {
      childList: true,
      subtree: true
    });

    updatePicker(picker, true);
  }

  function start() {
    document.querySelectorAll(
      'variant-picker'
    ).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded', start
    );
  } else {
    start();
  }
  new MutationObserver(() => {
    start();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();